<app-header [redirectToHome]="false" [isPrimary]="true"></app-header>

<!-- IMMAGINE CON MOTOTRE DI RICERCA -->
<div class="banner banner-3 dark-overlay-custom bg-cover bg-center">
  <img ngSrc="{{this.isMobile ? 'https://cdn.cercacasa.it/hero_img.jpeg?w=500': 'https://cdn.cercacasa.it/hero_img.jpeg?w=1920'}}" fill="center" alt="Sfondo cercacasa" priority="true"
    style="object-fit: cover;">
  <div class="container">
    <app-search-bar-input [isHome]="true"></app-search-bar-input>
  </div>
</div>

<!-- 3 DESCRIZIONI -->
<section class="cercacasaPromo">
  <div class="pt-5 pb-5 addBorderTop">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="footer__top">
            <b class="colorPrimary">Cercacasa.it</b>
            <h4>
              L’unico sito in Italia in cui trovi solo professionisti immobiliari abilitati e annunci
              verificati.
            </h4>
            <p class="mb-0">
              Su Cercacasa.it cerchi tra gli <b>annunci</b> di oltre <b>50.000 agenzie immobiliari
                abilitate</b> e <b>65.000 agenti immobiliari verificati</b> con <b>codice ATECO
                68.31</b>, dotati di <b>licenza</b> e <b>iscritti</b> alla <b>Camera di Commercio</b>.
            </p>
            <p>Perché scegliere <b>professionisti immobiliari verificati</b> per <b>vendere, comprare e
                affittare casa</b>:</p>
            <ul>
              <li>
                <p class="mb-0"><b>Esperienza, serietà</b> e <b>competenza</b>.</p>
              </li>
              <li>
                <p class="mb-0">Solo gli <b>Agenti Immobiliari</b> dotati di <b>regolare licenza</b>
                  hanno <b>diritto alla commissione</b>.</p>
              </li>
              <li>
                <p class="mb-0">Solo i <b>professionisti abilitati</b> hanno per legge una <b>copertura
                    assicurativa</b>
                  che <b>tutela i clienti</b> dai rischi come previsto dalla Legge n.39/89.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="firstDescription">
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="firstDescription__col border-right-col my-4 py-3">
          <div class="firstDescription__col--cont">
            <i class="icon-file-regular"></i>
            <div>
              <h4>Annunci Sicuri</h4>
              <p class="mb-0">
                Solo <b>annunci sicuri</b> con Informazioni
                certificate: <b>massimo standard</b> di qualità e <b>sicurezza</b>.
                Annunci con incarico <b>in esclusiva</b> e <b>verificati</b>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="firstDescription__col border-right-col my-4 py-3">
          <div class="firstDescription__col--cont">
            <i class="icon-check-circle"></i>
            <div>
              <h4>Agenti immobiliari verificati</h4>
              <p class="mb-0">
                Scegli il <b>professionista immobiliare</b> ideale
                per affiancarti con <b>serietà</b> e <b>competenza</b> nella
                ricerca della casa dei tuoi sogni.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="firstDescription__col my-4 py-3">
          <div class="firstDescription__col--cont">
            <i class="icon-user-tie"></i>
            <div>
              <h4>Consulenti del credito e assicurazione</h4>
              <p class="mb-0">
                Scegli il <b>professionista ideale</b> per un supporto qualificato
                nella scelta del <b>mutuo</b> o dell'<b>assicurazione</b>
                più adatti alle tue esigenze.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ANNUNCI VISITATI -->
<div *ngIf="this.visitedListing?.length > 0 || this.main?.visitedListings?.length > 0" class="container pt-5 pb-3"
  [hidden]="this.isLogged ? this.visitedListing?.length === 0 : this.main?.visitedListings?.length === 0">
  <div class="section-title-wrap section-title-wrap--cardSection4 section-header flex-header">
    <div class="section-title-text">
      <h3 class="pb-0 mb-3 fw-normal">Ultimi annunci visitati</h3>
    </div>
  </div>
  <app-carousel-annunci-recenti [contentArray]="this.visitedListing" class="carousel"></app-carousel-annunci-recenti>

  <div class="linkToUserList my-4">
    <p (click)="navigateToUserViditingListing()" class="fw-normal text-underline cursor-pointer colorPrimary">
      Tutti gli annunci visitati
    </p>
  </div>

</div>

<!-- AGENTI -->
<section class="cardSection4 pt-5 pb-5">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="section-title-wrap section-title-wrap--cardSection4 section-header">
              <h3 class="pb-0 mb-3 fw-normal">{{ this.isAgentSelected ? 'Agenti immobiliari' : 'Consulenti del credito'
                }}
                nella zona della tua ultima ricerca</h3>
            </div>
          </div>
          <div class="col-12 text-end d-flex align-items-center justify-content-end mb-4 filterContainer">

            <select *ngIf="this.isAgentSelected" class="form-control form-control-agents me-3"
              (change)="this.selectOrderAgent($event.target.value)">
              <option value="">Più pertinente</option>
              <option value="compravendite">Compravendite</option>
              <option value="locazioni">Locazioni</option>
              <option value="mutui_e_prestiti">Mutui/Prestiti</option>
              <option value="aste">Aste</option>
              <option value="property_finder">Property Finder</option>
              <option value="assicurazioni">Assicurazioni</option>
            </select>

            <div *ngIf="this.showProfessionist">
              <button (click)="this.selectFilter('agent')" class="btn btn-primary selectSearchTypeBtn me-3"
                [class.selectSearchTypeBtn_active]="!this.isAgentSelected">Agenti immobiliari
              </button>
              <button (click)="this.selectFilter('professionist')" class="btn btn-primary selectSearchTypeBtn"
                [class.selectSearchTypeBtn_active]="this.isAgentSelected">Consulenti del
                credito
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="this.isAgentSelected" class="cardSection4__cont">
          <app-loading class="loading-agent" *ngIf="this.agentLoading"></app-loading>
          <ng-container *ngFor="let agent of agentArray">
            <app-card-agente [agentObj]="agent" [agencyObj]="agent.agency"
              (openPopup)="this.openPopup()"></app-card-agente>
          </ng-container>
        </div>
        <div *ngIf="!this.isAgentSelected" class="cardSection4__cont">
          <app-loading class="loading-agent" *ngIf="this.professionistLoading"></app-loading>
          <ng-container *ngFor="let professionist of professionistArray">
            <app-card-professionista [professionistObj]="professionist" [brandObj]="professionist.brand"
              (openPopup)="this.openPopup()"></app-card-professionista>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- NEWS -->
<section *ngIf="this.latestArticlesArray?.length > 0" class="cardSection4 cardSection4--news pt-5 pb-5">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title-wrap section-title-wrap--cardSection4 section-header">
          <h3 class="pb-0 mb-3 fw-normal">Le ultime news dei nostri professionisti</h3>
        </div>
      </div>
      <div class="cardSection4__cont cardSection4__cont--news">
        <ng-container *ngFor="let article of this.latestArticlesArray">
          <app-news-card [isNewsAgentCard]="true" [article]="article"></app-news-card>
        </ng-container>
      </div>
    </div>
    <div class="linkToUserList my-4">
      <a [routerLink]="['/news']" class="fw-normal text-underline cursor-pointer colorPrimary">
        Tutti gli articoli
      </a>
    </div>
  </div>
</section>

<app-popup (closePopupEvent)="this.closePopup()" [modalIsOpen]="this.modalIsOpen" [reviewFormIsValid]="true"
  [isReviewPage]="false">
</app-popup>

<app-footer></app-footer>

<app-mobile-menu></app-mobile-menu>
